import styled from 'styled-components';

import {
  Card,
  Dimmer,
} from 'semantic-ui-react';

import { Header as HeaderLayoutComponent, ScrollBarContainer } from '@playbookux/playbook-web-core';

export const Container = styled(Dimmer)`
`;

export const Dialog = styled(Card)`
  &&& {
    padding: 30px;
    width: 600px;
    height: 400px;
    background-color: ${({ theme }) => theme.background};
    border-radius: 1px;
  }
`;

export const Header = styled(HeaderLayoutComponent)`
  text-align: justify;
  margin-bottom: 0px;
`;

export const List = styled.div`
  margin: 10px 0px;
  min-height: 100px;
  height: 100%;
  max-height: 400px;
  flex: 1;
  display: flex;
`;

export const ScrollBar = styled(ScrollBarContainer)`
`;
